import styled, { createGlobalStyle } from 'styled-components';

import { COLORS, SPACE } from '../../../../theme/tokens';
import { blobLayer, ringLayer, veilLayer } from '../../../blog-editor/generating.styles';

export {
  PanelRoot as MenuPanel,
  Item as MenuItem,
  ItemLabel as MenuItemLabel,
} from '../../../../components/ActionMenu/ActionMenu.styles';

/** Positioning context for the footer's Text / FAQ menu. */
export const Root = styled.div`
  position: relative;
  display: inline-flex;
`;

/**
 * Registers the travelling arc's angle once, as the blog's GeneratingWash does (`createGlobalStyle` dedupes across
 * every wash on the page). On engines that ignore animating a registered property the arc sits still.
 */
export const GlowAngleProperty = createGlobalStyle`
  @property --blog-write-glow-angle {
    syntax: '<angle>';
    inherits: false;
    initial-value: 0deg;
  }
`;

/** The fields a highlight can mark (the panels' `data-field` hooks). */
const MARKABLE = ['title', 'description', 'footer_text', 'llms_summary', 'llms_facts'];

/**
 * A panel Lumio writes into: the positioning context of its busy wash, and the highlight of each field still holding
 * what Lumio wrote (`data-generated` lists them; a field is found by its `data-field`). The radius is the Panel's,
 * so the wash follows its corners.
 */
export const Host = styled.div`
  position: relative;
  isolation: isolate;
  border-radius: 20px;

  ${MARKABLE.map((field) => `&[data-generated~='${field}'] [data-field='${field}']`).join(', ')} {
    border-radius: 12px;
    outline: 1px solid ${COLORS.lumioBorder};
    outline-offset: ${SPACE[4]};
  }
`;

/** The "Lumio is writing this" wash over the whole panel: the blog's field wash (veil, drifting colour, rim). */
export const Wash = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  border-radius: inherit;
  overflow: hidden;
  pointer-events: none;
`;

export const Veil = styled.span`
  ${veilLayer}
`;

export const Blobs = styled.span`
  ${blobLayer(26, 0.45)}
`;

export const Ring = styled.span`
  ${ringLayer}
`;

/** The status line, for assistive tech only (the wash carries nothing a screen reader can use). */
export const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
`;
